import TemplateSearchInput from './TemplateSearchInput';

export default TemplateSearchInput;
